<template>
  <!--  产品明细报表中 在途数量明细弹窗-->
  <div class="wayNumberDialogBox">
    <el-dialog :close-on-click-modal="false" class="new-dialog" :visible.sync="dialogFormVisible" width="88%"
               :before-close="dialogHide" title="在途数量列表">
      <div style="margin:0px">
        <div class="h-piece">
          <div class="h-formBox">
            <el-form :inline="true" :model="formInline" ref="formInline" label-width="150px"
                     class="demo-form-inline h-formBorder">
              <div>
                <el-form-item label="采购订单编号" prop="code">
                  <el-input v-model.trim="formInline.code" placeholder="" @keyup.enter.native="query"
                            maxlength="255" clearable></el-input>
                </el-form-item>
                <el-form-item label="供应商" prop="suserCode">
                  <el-input v-model.trim="formInline.suserCode" placeholder="" @keyup.enter.native="query"
                            maxlength="255" clearable></el-input>
                </el-form-item>
                <el-form-item label="订单创建时间" prop="queryTime">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.queryTime" type="daterange"
                                  range-separator="至" start-placeholder="" end-placeholder=""
                                  size="small"></el-date-picker>
                </el-form-item>
              </div>
              <div class="h-formBtnOut h-columnCenter">
                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData('formInline')">重置</el-button>
              </div>
            </el-form>
          </div>
        </div>
        <div class="h-row inventoryTableDialog">
          <div class="h-rowIn" style="width:100%;">
            <el-table
                ref="multipleTable"
                :data="tableData"
                stripe
                border
                max-height="450"
                :span-method="objectSpanMethod"
                style="width: 100%">
              <el-table-column
                  type="index"
                  fixed
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="code"
                  :show-overflow-tooltip="true"
                  min-width="130"
                  label="采购订单号">
              </el-table-column>
              <el-table-column
                  prop="suserName"
                  :show-overflow-tooltip="true"
                  min-width="130"
                  label="供应商">
              </el-table-column>
              <el-table-column
                  prop="productDes"
                  :show-overflow-tooltip="true"
                  min-width="130"
                  label="产品名称">
              </el-table-column>
              <el-table-column
                  prop="productNo"
                  :show-overflow-tooltip="true"
                  min-width="130"
                  label="产品编码">
              </el-table-column>
              <el-table-column
                  prop="count"
                  :show-overflow-tooltip="true"
                  min-width="100"
                  label="采购订单数量">
                <template slot-scope="scope">
                  <div style="text-align: right">
                    {{scope.row.count||0}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  :show-overflow-tooltip="true"
                  min-width="100"
                  label="采购订单状态">
                <template scope="scope">
                  <dictname category="cg_status" :v="scope.row.status"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="ldate"
                  :show-overflow-tooltip="true"
                  min-width="140"
                  label="订单创建时间">
                <template slot-scope="scope">
                  <div style="text-align: center;">
                    {{scope.row.cdate}}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
              <el-button class="h-btn h-formBtn" @click="exportData">
                导出
              </el-button>
              <div class="h-pagination2 h-pageCenter">
                <pagination :page="formInline" @query="query"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </el-dialog>

  </div>
</template>
<script>

  import ss from '../../../../api/SystemService';
  import updownfile from '../../../../utils/updownfile';

  export default {
    name: 'inventoryTable',
    data() {
      return {
        formInline: {
          code: '',//采购订单编号
          suserCode: '',//供应商
          cdatebegin: '',//订单创建时间开始日期
          cdateend: '',//订单创建时间结束日期
          queryTime: [],// 时间集合
          pageSize: 10,
          pageNo: 1,
          total: 0,
        },
        tableData: [],
        statusArr: [ //采购订单状态
          {name: '草稿', value: 0},
          {name: '待审核', value: 1},
          {name: '待确认', value: 2},
          {name: '待发货', value: 3},
          {name: '已发货', value: 4},
          {name: '确认收货', value: 5},
          {name: '驳回', value: 6},
        ],
        spanArr: [],   //游标集
        idlist: [],
        multipleSelection: [],
      }
    },
    props: {
      dialogFormVisible: {
        type: Boolean,
      },
      // 产地
      factory: {
          type: String,
      },
      prodcode: {
        type: String,
      }
    },
    created() {
      this.$set(this.formInline, 'prodcode', this.prodcode)
      this.$set(this.formInline, 'factory', this.factory)
      this.query();
    },
    methods: {
      //导出
      exportData(){
        updownfile.down("/api/swyl/v1/report/oemStock/downloadRoadExcel", this.formInline, "post");
      },
      //关闭弹窗框
      dialogHide(value) {
        this.$emit('dialogBoolHide', 'wayNumberDialog');
      },
      // 重置按钮
      resetData(formInline) {
        this.$refs[formInline].resetFields();
        this.query();
      },
      //主数据获取
      query() {
        let obj = JSON.parse(JSON.stringify(this.formInline))
        if (obj.queryTime && obj.queryTime.length > 0) {
          this.$set(obj, 'cdatebegin', obj.queryTime[0]);
          this.$set(obj, 'cdateend', obj.queryTime[1]);
        } else {
          obj.cdatebegin = '';
          obj.cdateend = '';
        }
        delete obj.queryTime;
        ss.inventory.selectRoadPage(obj).then(rd => {
          this.formInline.total = rd.total;
          this.tableData = rd.records;
          this.getSpanArr();
        })
      },
      //合并单元格方法
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        // if (column.label === '采购订单号') {
        //   //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
        //   const _row = this.spanArr[rowIndex];

        //   //该行跨了几列
        //   const _col = _row > 0 ? 1 : 0;
        //   return {
        //     rowspan: _row,
        //     colspan: _col
        //   }
        // }
      },
      //记录游标的方法
      getSpanArr() {

        //游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
        this.spanArr = [];

        //遍历当前表元素
        this.tableData.forEach((item, index) => {

          //当第一行时
          if (index === 0) {

            //默认先放第一行是1次
            this.spanArr.push(1);

            //记录当前重复行的位置
            this.position = 0;

            //其他行
          } else {

            //如果该行上的zhubiaoid与上一行上的zhubiaoid重复
            if (this.tableData[index].sapCode === this.tableData[index - 1].sapCode) {

              //从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
              this.spanArr[this.position] += 1;

              //因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
              this.spanArr.push(0);

              //若不重复
            } else {

              //继续向游标集放入一个1作为本行没有重复的独立一次记录
              this.spanArr.push(1);

              //记录重复行位置的游标移动到本行位置
              this.position = index;

            }
          }
        })
      },

    }
  }
</script>
